import { dynamicConfigNames } from '@mp/constants';
import { useDynamicConfig } from '@mp/hooks';

export const useSchedulingPrefsConfig = () => {
  const config = useDynamicConfig(dynamicConfigNames.schedulingPrefsConfig);

  return {
    shiftPreferences: config.get('shift_preferences', true) as boolean,
    dayPreferences: config.get('day_preferences', true) as boolean,
    frequencyPreferences: config.get('frequency_preferences', true) as boolean,
    positionPreferences: config.get('position_preferences', true) as boolean,
  };
};
